import React from "react";

interface LoadingDotsProps {
  /** Tailwind classes to apply to the container */
  className?: string;
  /** Tailwind classes to apply to each dot */
  dotClassName?: string;
}

export default function LoadingDots({
  className = "",
  dotClassName = "",
}: LoadingDotsProps) {
  return (
    <div
      className={`flex items-center justify-center space-x-[3px] mt-[5px] ${className}`}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={`
            ${dotClassName}
            h-1 w-1 bg-gray-200 rounded-full
            animate-bounce
          `}
          style={{ animationDelay: `${i * 0.2}s` }}
        />
      ))}
    </div>
  );
}
